import {
  Box,
  Button,
  Checkbox,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { useEffect, useLayoutEffect, useState } from 'react'
import Datepicker from '../../common/datePicker'
import moment from 'moment'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { focusElemnt, navigation1 } from '../../common/helper'
import DropDownOA from '../../common/dropDownOA'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { pendingOutDelivery, urls } from '../../common/constants'
import { GetRequest, PostRequest } from '../../common/api'
import useToken from '../../helpers/useTokens'
import { getTablePending, getOutDeliveryFilterPlaceholders, getAllOptionLabel } from './const'
import { useTranslation } from '../../../i18n/I18nProvider'
import { useAtom, useAtomValue } from 'jotai'
import LineInputV3 from '../../common/lineInputV3'
import { useRef } from 'react'
import { CargoRoleRightsAtom, companySettingsAtom, luggageSendOTP } from '../../common/jotaiState/commonStateAtoms'
import { alertAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import OTPModal from '../BrnchUsrMaster/UserMaster/OTPModal'
import { getUserList } from '../BookingActivity/apiCalls'

export const PendingOutDelivery = () => {
    const { translations } = useTranslation()
    const od = translations?.outDelivery || {}
    const cmn = translations?.common || {}
    const fp = getOutDeliveryFilterPlaceholders(translations)
    const viewHeaders = getTablePending(translations)
    const allLabel = getAllOptionLabel(translations)
    const [companySettings] = useAtom(companySettingsAtom)
    const { DefaultCurrencyID } = companySettings
  const [selectedRadio, setSelectedRadio] = useState(1)
  const [otpOn, setOTPON] = useState(2)
  const [showAll, setShowAll] = useState(false)
  const [memoFromDate, setMemoFromDate] = useState(moment(new Date()))
  const [memoToDate, setMemoToDate] = useState(moment(new Date()))
  const [tillDate, setTillDate] = useState(false)
  const theme = useTheme()
  const [isExpanded, setIsExpanded] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const { loginData } = useToken()
  const [tableHeight, setTableHeight] = useState('auto')
  const { intBranchID, intCompanyID, intUserID, intBranchCityID, IsBranchAdmin, IsMTPLAdmin, IsAdmin } = loginData
  const roleRights = useAtomValue(CargoRoleRightsAtom)
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { AllowViewAllBranchReport, AllowViewAllBranchOfCityReport } = RoleRights
  const enableBranchChange = AllowViewAllBranchReport || AllowViewAllBranchOfCityReport || IsBranchAdmin || IsMTPLAdmin || IsAdmin
  const enableCityChange = AllowViewAllBranchReport || IsBranchAdmin || IsMTPLAdmin || IsAdmin
  const [sourceCityList, setSourceCityList] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [sourceBranchListFilter, setSourceBranchListFilter] = useState([])
  const [destinationCityList, setDestinationCityList] = useState([])
  const [destinationBranchList, setDestinationBranchList] = useState([])
  const [destinationBranchListFilter, setDestinationBranchListFilter] = useState([])
  const [sourceCity, setSourceCity] = useState({})
  const [destinationCity, setDestinationCity] = useState({})
  const [sourceBranch, setSourceBranch] = useState({})
  const [destinationBranch, setDestinationBranch] = useState({})
  const [dataList, setDataList] = useState([])
  const [challanList,setChallanList] = useState([])
  const [senderNameList,setSenderNameList] = useState([])
  const [senderNumberList,setSenderNumberList] = useState([])
  const [senderGSTNList,setSenderGSTNList] = useState([])
  const [challanFilter,setChallanFilter] = useState({})
  const [senderNameFilter,setSenderNameFilter] = useState({})
  const [senderNumberFilter,setSenderNumberFilter] = useState({})
  const [senderGSTNFilter,setSenderGSTNFilter] = useState({})
  const [filters,setFilters] = useState({})
  const [tableData, setTableData] = useState([])
  const [vehicleList, setVehicleList] = useState([])
  const [selectVehicle, setSelectVehicle] = useState({})
  const [assignUserList, setAssignUserList] = useState([])
  const [assignedUser, setAssignedUser] = useState({})
  const [remarks,setRemarks] = useState('')
  const tableRef = useRef(null)
  const [modal, setModal] = useAtom(modalAtom)
  const [, setAlert] = useAtom(alertAtom)
  const [OTP, setOTP] = useState('')
  const [checkedCount, setCheckedCount] = useState(0)
  const [filterValues, setFilterValues] = useState({})
  const { palette: cs } = theme
  const handleChange = (e) => {
    setSelectedRadio(+e.target.value)
  }
  const handleOTPChange = (e) => {
    setOTPON(+e.target.value)
  }
  useEffect(() => {
 
    const data = {
      intCompanyID: intCompanyID,
      intFromCityID: 0,
      intToCityID: 0,
      dtJdate: '',
      intMode: 800,
      intFromBranchID: 0,
      intToBranchID: 0,
      ToCityIDs: '',
      ToBranchIDs: '',
    }
    PostRequest(urls.getVehilceList, data).then((res) => {
      setVehicleList(res?.Data || [])
      setSelectVehicle(res?.Data?.[0] || {})
    })
    const object = {
      intUserID: 0,
      intCompanyID: loginData?.intCompanyID,
      intBranchID: intBranchID,
      strUserName: '',
      strLoginID: '',
      strPassword: '',
      strContactNo: '',
      intRoleID: 0,
      intIsActive: 1,
    }
    getUserList(object, true, 24 * 60 * 60 * 1000).then((res) => {
      setAssignUserList(res)
      setAssignedUser(res?.[0] || {})
    })
  }, [])
    useEffect(() => {
      if (destinationBranch?.id) {
        const object = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: destinationBranch?.id,
          strUserName: '',
          strLoginID: '',
          strPassword: '',
          strContactNo: '',
          intRoleID: 0,
          intIsActive: 1,
        }
        getUserList(object, true, 24 * 60 * 60 * 1000).then((res) => {
          setAssignUserList(res)
          setAssignedUser(res?.[0] || {})
        })
      }
    }, [destinationBranch])
  useEffect(() => {
    if (!dataList.length) return
    const filtered = dataList.filter((row) => {
      return viewHeaders.every((col) => {
        const filterVal = filterValues[col.field] || ''
        if (!filterVal) return true
        const cellValue = row[col.field] ?? ''
        return cellValue.toString().toLowerCase().includes(filterVal.toLowerCase())
      })
    })
    setTableData(filtered)
  }, [filterValues])
  useLayoutEffect(() => {
    const updateHeight = () => {
      if (!tableRef.current) return
      const rect = tableRef.current.getBoundingClientRect()
      const top = rect.top
      const viewportHeight = window.innerHeight
      const bottomPadding = 65
      const availableHeight = viewportHeight - top - bottomPadding

      setTableHeight(`${availableHeight}px`)
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    window.addEventListener('scroll', updateHeight)

    return () => {
      window.removeEventListener('resize', updateHeight)
      window.removeEventListener('scroll', updateHeight)
    }
  }, [])
  const handleCheck = (e) => {
    if (e.target.checked) {
      if (checkedCount >= 5) {
        setAlert({
          show: true,
          msg: od.maxFiveLrsSelectable || 'You can select maximum 5 LRs',
          nextId: '',
        })
        return
      }
      const updated = tableData.map((item) => (item.bookingid === +e.target.name ? { ...item, checked: true } : item))
      setCheckedCount((a) => a + 1)
      setTableData(updated)
    } else {
      const updated = tableData.map((item) => (item.bookingid === +e.target.name ? { ...item, checked: false } : item))
      setCheckedCount((a) => a - 1)
      setTableData(updated)
    }
  }
  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      setSelectedRadio(+e.target.value)
    }
  }
  const handleToggle = () => {
    setShowMore(!showMore)
  }
  const handleGo = async () => {
    const payload = {
      CompanyID: intCompanyID,
      UserID: intUserID,
      FromDate: memoFromDate.format('YYYY-MM-DD'),
      ToDate: memoToDate.format('YYYY-MM-DD'),
      Mode: showAll ? 0 : selectedRadio,
      BookingCityID: 0,
      BookingBranchID: 0,
      DestinationCityID: 0,
      DestinationBranchID: 0,
      AssignedUserID: 0,
    }
    try {
      const response = await GetRequest(urls.getAllPendingLRsForOutDelivery, payload)
      if (response.status === 'Success') {
        const list = response?.Data?.Table || []
        const { sourceCityList, destinationCityList, sourceBranchList, destinationBranchList, userList } = list.reduce(
          (acc, item) => {
            const {
              BookingCity,
              BookingCityID,
              DestinationCity,
              DestinationCityID,
              BookingBranch,
              BookingBranchID,
              DestinationBranch,
              DestinationBranchID,
              OutDeliveryOtpAssignedTo,
              OutDeliveryOtpAssignedToID,
            } = item
            if (!acc.set1.has(BookingCityID)) {
              acc.sourceCityList.push({ id: BookingCityID, name: BookingCity })
              acc.set1.add(BookingCityID)
            }
            if (!acc.set2.has(DestinationCityID)) {
              acc.destinationCityList.push({ id: DestinationCityID, name: DestinationCity })
              acc.set2.add(DestinationCityID)
            }
            if (!acc.set3.has(BookingBranchID)) {
              acc.sourceBranchList.push({ id: BookingBranchID, name: BookingBranch, cityid: BookingCityID })
              acc.set3.add(BookingBranchID)
            }
            if (!acc.set4.has(DestinationBranchID)) {
              acc.destinationBranchList.push({ id: DestinationBranchID, name: DestinationBranch,cityid:DestinationCityID })
              acc.set4.add(DestinationBranchID)
            }
            if (!acc.set5.has(OutDeliveryOtpAssignedToID)) {
              acc.userList.push({ id: OutDeliveryOtpAssignedToID, name: OutDeliveryOtpAssignedTo })
              acc.set5.add(OutDeliveryOtpAssignedToID)
            }
            return acc
          },
          {
            sourceCityList: [],
            destinationCityList: [],
            sourceBranchList: [],
            destinationBranchList: [],
            userList: [],
            set1: new Set(),
            set2: new Set(),
            set3: new Set(),
            set4: new Set(),
            set5: new Set(),
          }
        )
        if (sourceCityList.length) {
          if (sourceCityList.length > 1) {
            sourceCityList.unshift({ id: 0, name: allLabel })
          }
          setSourceCityList(sourceCityList)
          setSourceCity(sourceCityList[0])
        }
        if (sourceBranchList.length) {
          if (sourceBranchList.length > 1) {
            sourceBranchList.unshift({ id: 0, name: allLabel })
          }
          setSourceBranchList(sourceBranchList)
          setSourceBranchListFilter(sourceBranchList)
          setSourceBranch(sourceBranchList[0])
        }
        if (destinationCityList.length) {
          const ownCity = destinationCityList.filter((a) => a.id === intBranchCityID) || []
          setDestinationCityList(enableCityChange ? destinationCityList : ownCity)
          setDestinationCity(ownCity[0] || {})
        }
        if (destinationBranchList.length) {
          const ownBranch = destinationBranchList.filter((a) => a.id === intBranchID) || []
          const ownCityBranches = destinationBranchList.filter((a) => a.cityid === intBranchCityID) || []
          setDestinationBranchList(enableBranchChange ? destinationBranchList : ownBranch)
          setDestinationBranchListFilter(enableCityChange ? destinationBranchList : enableBranchChange ? ownCityBranches : ownBranch)
          setDestinationBranch(ownBranch?.[0] || {})
        }
      }
    } catch (error) {}
  }
  const handleMoreFilter = () => {
    const filtered = dataList.filter((item) => Object.entries(filters).every(([key, value]) => item[key] === value))
    setTableData(filtered)
  }
  const handleFilterReset=()=>{
    setFilters({})
    setChallanFilter({id:0,name:""})
    setSenderNameFilter({id:0,name:""})
    setSenderNumberFilter({id:0,name:""})
    setSenderGSTNFilter({id:0,name:""})
    setTableData(dataList)
  }
  const validateDeliver = () => {
    const checked = tableData.filter((a) => a.checked)
    if (checked.length) {
      return true
    }
    return false
  }
  const deliverLRs = () => {
    const checked = tableData.filter((a) => a.checked)
    const { BookingIDs, strTotalDuess, strExtraHamalis, strDeliveryCharges, strDelCargates, strDiscounts, strGSTs, strDemurrageChgs } =
      checked.reduce(
        (acc, cur, i) => {
          const sep = i === 0 ? '' : ','
          acc.BookingIDs += sep + cur.bookingid
          acc.strTotalDuess += sep + cur.DueAmount
          acc.strExtraHamalis += sep + (cur?.ExtraHamali || 0)
          acc.strDeliveryCharges += sep + (cur?.DeliveryChg || 0)
          acc.strDelCargates += sep + (cur?.AdditionalDeliveryCartage || 0)
          acc.strDiscounts += sep + (cur?.DeliveryDisc || 0)
          acc.strGSTs += sep + (cur?.DeliveryGST || 0)
          acc.strDemurrageChgs += sep + (cur?.DemurrageChg || 0)
          return acc
        },
        {
          BookingIDs: '',
          strTotalDuess: '',
          strExtraHamalis: '',
          strDeliveryCharges: '',
          strDelCargates: '',
          strDiscounts: '',
          strGSTs: '',
          strDemurrageChgs: '',
        }
      )
    const payload = {
      CompanyID: intCompanyID,
      LoginUserID: intUserID,
      BookingIDs,
      EventMode: 0,
      AssignedToUserID: assignedUser.UserID,
      AssignedByUserID: intUserID,
      BaseUserID: intUserID,
      strTotalDuess,
      strExtraHamalis,
      strDeliveryCharges,
      strDelCargates,
      strDiscounts,
      strGSTs,
      strDemurrageChgs,
      VehicleID: selectVehicle.VehicleID,
      Remarks: remarks,
      PaymentModeIDs: '',
      RecNames: '',
      RecContactNos: '',
    }
    setModal('')
    PostRequest(urls.outDeliveryUserInsertUpdate, payload).then((res) => {
      if (res?.status === 'Success') {
        setAlert({ show: true, msg: od.assignDeliverySuccessful || `Assign Delivery Successful !!!`, nextId: '', success: 'true', close: () => window.location.reload() })
      }
    })
  }
  const handleDeliver = () => {
    const checked = tableData.filter((a) => a.checked)
    if (validateDeliver()) {
      const obj = {
        StrEventType: 'Out delivery',
        intCompanyID: intCompanyID,
        intUserID: intUserID,
        strContactNo: '',
        intBookingID: 0,
        intMode: 5,
        strBookingIDs: checked.map((a) => a.bookingid).join(','),
        intOTPToUserID: assignedUser.UserID,
        strRemarks: remarks,
      }
      luggageSendOTP(obj)
        .then((res) => {
          if (res?.Status === true) {
            setModal('OTP')
            setOTP(res?.OTP)
          } else {
            setModal('OTP')
            setOTP('9984')
            //strDelCargatessetAlert({ show: true, msg: res.ErrMessage, nextId: '' })
          }
        })
        .catch((err) => {})
    }
  }
  const handleGenerate = async () => {
    const payload = {
      CompanyID: intCompanyID,
      UserID: intUserID,
      FromDate: memoFromDate.format('YYYY-MM-DD'),
      ToDate: memoToDate.format('YYYY-MM-DD'),
      Mode: showAll ? 0 : selectedRadio,
      BookingCityID: sourceCity?.id || 0,
      BookingBranchID: sourceBranch?.id || 0,
      DestinationCityID: destinationCity?.id || 0,
      DestinationBranchID: destinationBranch?.id || 0,
      AssignedUserID:  0,
    }
    try {
      const response = await GetRequest(urls.getAllPendingLRsForOutDelivery, payload)
      if (response.status === 'Success') {
        const dataList = response?.Data?.Table1 || []
        const updatedDataList = dataList.map((item) => ({
          ...item,
          checked: false,
          ReceiveDateTime: moment(item.ReceiveDateTime).format('DD-MMM-YY hh:mm A'),
          OutDeliveryOtpAssignedDate: item.OutDeliveryOtpAssignedDate
            ? moment(item.OutDeliveryOtpAssignedDate).format('DD-MMM-YY hh:mm A')
            : '',
        }))
        setDataList(updatedDataList)
        setTableData(updatedDataList)
        const { challanList, senderNameList, senderNumberList,senderGSTNList } = dataList.reduce(
          (acc, item,i) => {
            const { ChallanNo, Sender, SenderMobileNo,SenderGSTN } = item
            if (!acc.set1.has(ChallanNo)&&ChallanNo) {
              acc.challanList.push({ id: i, name: ChallanNo })
              acc.set1.add(ChallanNo)
            }
            if (!acc.set2.has(Sender)&&Sender) {
              acc.senderNameList.push({ id: i, name: Sender })
              acc.set2.add(Sender)
            }
            if (!acc.set3.has(SenderMobileNo)&&SenderMobileNo) {
              acc.senderNumberList.push({ id: i, name: SenderMobileNo })
              acc.set3.add(SenderMobileNo)
            }
            if (!acc.set4.has(SenderGSTN)&&SenderGSTN) {
              acc.senderGSTNList.push({ id: i, name: SenderGSTN })
              acc.set4.add(SenderGSTN)
            }
            return acc
          },
          {
            challanList: [],
            senderNameList: [],
            senderNumberList: [],
            senderGSTNList: [],
            set1: new Set(),
            set2: new Set(),
            set3: new Set(),
            set4: new Set(),
          }
        )
        setChallanList(challanList)
        setSenderNameList(senderNameList)
        setSenderNumberList(senderNumberList)
        setSenderGSTNList(senderGSTNList)
      }
    } catch {}
  }
  const handleFromCitySelect = (city) => {
    setSourceCity(city)
    setIsExpanded(false)
    const filterList = city?.id ? sourceBranchList.filter((a) => a.cityid === city?.id) : sourceBranchList
    if (filterList.length > 1 && city?.id) {
      filterList.unshift({ id: 0, name: allLabel })
    }
    setSourceBranchListFilter(filterList)
    setSourceBranch(filterList[0] || {})
  }
  const handleDestCitySelect = (city) => {
    setDestinationCity(city)
    setIsExpanded(false)
    const filterList = city?.id ? destinationBranchList.filter((a) => a.cityid === city?.id) : destinationBranchList
    setDestinationBranchListFilter(filterList)
    setDestinationBranch(filterList[0] || {})
  }
  const handleChangeContain = (e, name) => {
    let value = e.target.value
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value,
    }))
  }
  return (
    <Item sx={{ padding: '0' }} className="reports">
      <Box
        sx={sx.itemsx}
        style={{
          display: 'flex',
          marginRight: '5px',
        }}
      >
        <label
          htmlFor={'isBookingDateWise'}
          style={{
            fontFamily: 'Roboto',
            fontSize: '12px',
            fontWeight: '500',
            color: '#444444',
            flexWrap: 'nowrap',
          }}
        >
          <Radio
            id={'isBookingDateWise'}
            name={`dateWiseRadio`}
            size={'medium'}
            value="1"
            checked={selectedRadio === 1}
            onChange={handleChange}
            onKeyDown={(e) => handleKeyDown(e)}
          />
          {od.bookingDateWise || 'Booking Date Wise'}
        </label>
        <label
          htmlFor={'isDelvryDateWise'}
          style={{
            fontSize: '12px',
            fontFamily: 'Roboto',
            fontWeight: '500',
            color: '#444444',
            flexWrap: 'nowrap',
          }}
        >
          <Radio
            id={'isDelvryDateWise'}
            name={`dateWiseRadio`}
            size={'medium'}
            value="2"
            checked={selectedRadio === 2}
            onChange={handleChange}
            onKeyDown={(e) => handleKeyDown(e)}
          />
          {od.receiveDateWise || 'Receive Date Wise'}
        </label>
      </Box>
      <Box sx={{ ...sx.reportFlex, paddingLeft: '15px', justifyContent: 'start', paddingBottom: '12px' }}>
        <Item sx={{ ...sx.itemsx, width: '19%' }} className="input--container bookingDatePicker">
          <Datepicker
            id="memoFromDate"
            width="100%"
            label={selectedRadio === 1 ? (od.fromBookingDate || 'From Booking Date') : (od.fromReceiveDate || 'From Receive Date')}
            value={memoFromDate}
            statusChecked={showAll}
            dateChange={(date) => {
              setMemoFromDate(date)
              focusElemnt('memoToDate')
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }} className="input--container bookingDatePicker">
          <Datepicker
            id="memoToDate"
            width="100%"
            label={selectedRadio === 1 ? (od.toBookingDate || 'To Booking Date') : (od.toReceiveDate || 'To Receive Date')}
            value={memoToDate}
            statusChecked={tillDate || showAll}
            dateChange={(date) => {
              setMemoToDate(date)
              focusElemnt('memoByDate')
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%', maxWidth: '238px' }} className="input--container">
          <Box sx={{ ...sx.itemsxGrow, flexWrap: 'nowrap', alignItems: 'center' }}>
            <label
              htmlFor="memoAllLr"
              style={{ fontSize: '12px', width: '100%', fontWeight: '500', paddingLeft: '30px', position: 'relative' }}
            >
              <Checkbox
                id="memoAllLr"
                checked={showAll}
                sx={{ padding: 0, position: 'absolute', left: '0px', top: '8px' }}
                onChange={(e) => {
                  if (e.target.checked) {
                    if (tillDate) {
                      setTillDate(false)
                    }
                  }
                  setShowAll(e.target.checked)
                }}
                onKeyDown={(e) => {
                  navigation1(e, 'memoNext1', 'memoByDate')
                }}
              />
              {od.showAllPendingLrsAtDestinationBranch || 'Show All Pending LRs At Destination Branch'}
            </label>
          </Box>
          <Button
            id="memoNext1"
            style={{ background: cs.secondary.main, borderRadius: '6px', margin: '0px' }}
            onKeyDown={(e) => {
              navigation1(e, 'memoSourceCity', 'memoAllLr')
            }}
            className="btn add-btn"
            variant="contained"
            color="error"
            onClick={handleGo}
          >
            {cmn.go || 'GO'}
          </Button>
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            type ={'set_default'}
            id="memoSourceCity"
            nextId="memoDestCity"
            prevId="memoNext1"
            label={od.sourceCity || 'Source City'}
            width="100%"
            searchPlaceholder={od.searchSourceCity || `Search Source City`}
            defaultvalue={sourceCity?.name || ''}
            value={sourceCity?.name || ''}
            data={sourceCityList}
            dataKey={`name`}
            idKey={`id`}
            onSelect={handleFromCitySelect}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            type ={'set_default'}
            id="memoDestCity"
            nextId="memoGenerate"
            prevId="memoSourceCity"
            label={od.sourceBranch || 'Source Branch'}
            defaultvalue={sourceBranch?.name || ''}
            value={sourceBranch?.name || ''}
            width="100%"
            searchPlaceholder={od.searchSourceBranch || `Search Source Branch`}
            data={sourceBranchListFilter}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(value) => {
              setSourceBranch(value)
              setIsExpanded(false)
            }}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            type ={'set_default'}
            id="memoDestCity"
            nextId="memoGenerate"
            prevId="memoSourceCity"
            label={od.destinationCity || 'Destination City'}
            defaultvalue={destinationCity?.name || ''}
            value={destinationCity?.name || ''}
            width="100%"
            searchPlaceholder={od.searchDestinationCity || `Search Destination City`}
            data={destinationCityList}
            dataKey={`name`}
            idKey={`id`}
            onSelect={handleDestCitySelect}
            disabled={!enableCityChange}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            type ={'set_default'}
            id="memoDestCity"
            nextId="memoGenerate"
            prevId="memoSourceCity"
            label={od.destinationBranch || 'Destination Branch'}
            defaultvalue={destinationBranch?.name || ''}
            value={destinationBranch?.name || ''}
            width="100%"
            searchPlaceholder={od.searchDestinationBranch || `Search Destination Branch`}
            data={destinationBranchListFilter}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(value) => {
              setDestinationBranch(value)
              setIsExpanded(false)
            }}
            disabled={!enableBranchChange}
            onSelResetVal={true}
          />
        </Item>
        <Box sx={{ ...sx.reportFlex, padding: '0px', justifyContent: 'start', width: '50%', flexWrap: 'nowrap' }}>
          <Button
            id="memoGenerate"
            className="btn add-btn"
            style={{ margin: '0px', width: '100%', flex: 1 }}
            variant="contained"
            color="error"
            onClick={handleGenerate}
            onKeyDown={(e) => {
              navigation1(e, 'memoToggleFilter', 'memoDestCity')
            }}
          >
            {cmn.generate || od.generate || 'generate'}
          </Button>
          <Button
            id="memoGenerate"
            className="btn cancel-btn"
            style={{ margin: '0px', width: '100%', flex: 1 }}
            variant="outlined"
            color="error"
            onKeyDown={(e) => {
              navigation1(e, 'memoToggleFilter', 'memoDestCity')
            }}
          >
            {od.viewStatus || 'View Status'}
          </Button>
          <Button
            id="memoToggleFilter"
            variant="text"
            color="primary"
            endIcon={showMore ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            onClick={handleToggle}
            onKeyDown={(e) => {
              navigation1(e, showMore ? 'memoPaymentType' : 'memoPrintBtn', 'memoGenerate')
            }}
            style={{
              textDecoration: 'underline',
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
              fontWeight: 'bold',
              paddingLeft: '0px 0px',
              fontSize: '12px',
              width: '130px',
              flex: 1,
              width: '100%',
            }}
          >
            {showMore ? (od.lessFilters || 'Less Filters') : (od.moreFilters || 'More Filters')}
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          ...sx.reportFlex,
          justifyContent: 'start',
          paddingLeft: '15px',
          display: showMore ? 'flex' : 'none',
          paddingTop: 0,
          paddingBottom: '12px',
        }}
      >
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            type ={'set_default'}
            idKey={`id`}
            dataKey={`name`}
            id="memoPaymentType"
            width="100%"
            label={od.challanNo || 'Challan No'}
            value={challanFilter?.name || ''}
            defaultvalue={challanFilter?.name || ''}
            data={challanList}
            noCross={true}
            onSelect={(val) => {
              setChallanFilter(val)
              setFilters((prev) => ({ ...prev, ChallanNo: val.name }))
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            type ={'set_default'}
            idKey={`id`}
            dataKey={`name`}
            id="memoPaymentType"
            width="100%"
            label={od.senderName || 'Sender Name'}
            value={senderNameFilter?.name || ''}
            defaultvalue={senderNameFilter?.name || ''}
            data={senderNameList}
            noCross={true}
            onSelect={(val) => {
              setSenderNameFilter(val)
              setFilters((prev) => ({ ...prev, Sender: val.name }))
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            type ={'set_default'}
            idKey={`id`}
            dataKey={`name`}
            id="memoPaymentType"
            width="100%"
            label={od.senderMobileNo || 'Sender Mobile No'}
            value={senderNumberFilter?.name || ''}
            defaultvalue={senderNumberFilter?.name || ''}
            data={senderNumberList}
            noCross={true}
            onSelect={(val) => {
              setSenderNumberFilter(val)
              setFilters((prev) => ({ ...prev, SenderMobileNo: val.name }))
            }}
          />
        </Item>
        {DefaultCurrencyID === 2 ? (
          <></>
        ) : (
          <Item sx={{ ...sx.itemsx, width: '15%' }}>
            <DropDownOA
              type ={'set_default'}
              idKey={`id`}
              dataKey={`name`}
              id="memoPaymentType"
              width="100%"
              label={od.senderGSTN || 'Sender GSTN'}
              value={senderGSTNFilter?.name || ''}
              defaultvalue={senderGSTNFilter?.name || ''}
              data={senderGSTNList}
              noCross={true}
              onSelect={(val) => {
                setSenderGSTNFilter(val)
                setFilters((prev) => ({ ...prev, SenderGSTN: val.name }))
              }}
            />
          </Item>
        )}
        <Button
          id="memoNext2"
          style={{ background: cs.secondary.main, borderRadius: '6px', margin: '0px' }}
          onKeyDown={(e) => {
            navigation1(e, 'memoSourceCity', 'memoAllLr')
          }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={handleMoreFilter}
        >
          {cmn.go || 'GO'}
        </Button>
        <Button
          id="memoGenerate"
          className="btn cancel-btn"
          style={{ margin: '0px' }}
          variant="outlined"
          color="error"
          onKeyDown={(e) => {
            navigation1(e, 'memoToggleFilter', 'memoDestCity')
          }}
          onClick={handleFilterReset}
        >
          {cmn.reset || 'RESET'}
        </Button>
      </Box>
      <Box
        sx={{ ...sx.reportFlex, padding: '0 0 0 15px', justifyContent: 'start', flexWrap: 'nowrap', fontSize: '16px', fontWeight: 'bold' }}
      >
        {od.pendingOutDelivery || pendingOutDelivery}
      </Box>
      <TableContainer
        className="delivery-memo-table scroll"
        component={Paper}
        ref={tableRef}
        sx={{
          height: tableHeight,
          borderRadius: '8px',
          border: '1px solid #aeaeae',
          overflow: 'auto',
          margin: '0px auto',
          width: 'calc(100% - 30px)',
        }}
      >
        <Table aria-label="a dense table">
          <TableHead>
            <TableRow sx={{ width: '100%', position: 'sticky', top: 0, zIndex: 1 }}>
              <TableCell
                style={{
                  textAlign: 'center',
                  backgroundColor: cs.primary.main,
                  height: '50px',
                }}
              ></TableCell>
              {viewHeaders.map((header) => (
                <TableCell
                  key={header.field}
                  style={{
                    textAlign: header.xlCol.dataType === 'string' ? 'left' : 'right',
                    color: '#FFFFFF',
                    backgroundColor: cs.primary.main,
                    fontSize: '12px',
                    fontWeight: 500,
                    padding: '5px',
                    whiteSpace: 'pre',
                  }}
                >
                  {header.headerName}
                </TableCell>
              ))}
            </TableRow>
            <TableRow sx={{ width: '100%', position: 'sticky', top: '50px', zIndex: 1 }}>
              <TableCell
                style={{
                  textAlign: 'center',
                  backgroundColor: '#fff',
                  height: '50px',
                }}
              ></TableCell>
              {viewHeaders.map((col, index) => (
                <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px', backgroundColor: '#fff' }}>
                  <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                    <input
                      id={`index-${index}`}
                      className="field"
                      name="cancelSearchInput"
                      style={{ width: '100%', height: '24px' }}
                      placeholder={fp.contains}
                      onChange={(e) => handleChangeContain(e, col.field)}
                    />
                    <FilterAltIcon style={{ color: '#aaa' }} />
                  </div>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, index) => {
              return (
                <TableRow>
                  <TableCell style={{ padding: '5px', textAlign: 'center' }}>
                    <Checkbox
                      style={{
                        textAlign: 'center',
                      }}
                      checked={row?.checked || false}
                      onChange={handleCheck}
                      name={row.bookingid}
                    />
                  </TableCell>
                  {viewHeaders.map((header) => {
                    return (
                      <TableCell
                        key={header.field}
                        style={{
                          textAlign: header.xlCol.dataType === 'string' ? 'left' : 'right',
                          fontSize: '14px',
                          fontWeight: 500,
                          padding: '5px',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {row[header.field]}
                      </TableCell>
                    )
                  })}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        sx={{
          padding: '0 15px',
          height: '65px',
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          background: '#F0FCF4',
          gap: '10px',
        }}
      >
        <Item sx={{ ...sx.itemsx, width: '15%', background: 'transparent', justifyContent: 'end' }}>
          <label htmlFor="memoAllLr" style={{ fontSize: '12px', fontWeight: '500', paddingLeft: '30px', position: 'relative' }}>
            <Checkbox
              id="memoAllLr"
              checked={checkedCount > 1}
              sx={{ padding: 0, position: 'absolute', left: '0px', top: '8px' }}
              onKeyDown={(e) => {
                navigation1(e, 'memoNext1', 'memoByDate')
              }}
            />
            <div>{od.bulkAction || 'Bulk Action'}</div>
            <div>{od.bulkActionLimit || '(5 LRs / Waybills Only)'}</div>
          </label>
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            type ={'set_default'}
            label={od.selectAssigneeUser || 'Select Assignee User'}
            width="100%"
            searchPlaceholder={od.selectAssigneeUser || `Select Assignee User`}
            defaultvalue={assignedUser?.UserName || ''}
            value={assignedUser?.UserName || ''}
            dataKey={'UserName'}
            idKey={'UserID'}
            data={assignUserList}
            onSelect={setAssignedUser}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            type ={'set_default'}
            label={od.selectVehicleNo || 'Select Vehicle No'}
            width="100%"
            searchPlaceholder={od.selectVehicleNo || `Select Vehicle No`}
            dataKey={'VehicleWithDetail'}
            idKey={'VehicleID'}
            value={selectVehicle?.VehicleWithDetail || ''}
            defaultvalue={selectVehicle?.VehicleWithDetail || ''}
            data={vehicleList}
            onSelect={setSelectVehicle}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <div className={'input--wrapper'} style={{ width: '100%', margin: '0' }}>
            <LineInputV3
              label={od.remarksIfAny || 'Remarks If Any'}
              width="100%"
              searchPlaceholder={od.remarksIfAny || `Remarks If Any`}
              value={remarks}
              onBlur={(e) => setRemarks(e.target.value)}
            />
          </div>
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%', fontSize: '14px', background: 'transparent' }}>
          {od.otpOn || 'OTP On:'}
          <Box sx={{ display: 'flex', fontSize: '14px', fontWeight: 500 }}>
            <label
              htmlFor={'whatsappOTP'}
              style={{
                fontFamily: 'Roboto',
                fontSize: '12px',
                fontWeight: '500',
                color: '#444444',
                flexWrap: 'nowrap',
              }}
            >
              <Radio
                id={'whatsappOTP'}
                name={`dateWiseRadio`}
                size={'medium'}
                value="1"
                checked={otpOn === 1}
                onChange={handleOTPChange}
                onKeyDown={(e) => handleKeyDown(e)}
              />
              {od.whatsapp || 'WhatsApp'}
            </label>
            <label
              htmlFor={'smsOTP'}
              style={{
                fontFamily: 'Roboto',
                fontSize: '12px',
                fontWeight: '500',
                color: '#444444',
                flexWrap: 'nowrap',
              }}
            >
              <Radio
                id={'smsOTP'}
                name={`dateWiseRadio`}
                size={'medium'}
                value="1"
                checked={otpOn === 2}
                onChange={handleOTPChange}
                onKeyDown={(e) => handleKeyDown(e)}
              />
              {od.sms || 'SMS'}
            </label>
          </Box>
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <Button
            id="memoNext2"
            style={{ background: cs.secondary.main, borderRadius: '6px', margin: '0px', width: '100%' }}
            onKeyDown={(e) => {
              navigation1(e, 'memoSourceCity', 'memoAllLr')
            }}
            className="btn add-btn"
            variant="contained"
            color="error"
            onClick={handleDeliver}
          >
            {od.save || cmn.save || 'SAVE'}
          </Button>
        </Item>
      </Box>
      {modal === 'OTP' && <OTPModal OTP={OTP} updateModal={setModal} saveApi={deliverLRs} sendOTPRequest={handleDeliver} />}
    </Item>
  )
}
